<template>
  <div class="customer__pool" :class="{active:repaymentList.length>0}">
<!--    <div class="customer__pool__title__parent">-->
<!--      <div class="customer__pool__icon iconfont">测试</div>-->
<!--      <div class="customer__pool__title">-->
<!--        <span>客户回款池</span>-->
<!--      </div>-->
<!--    </div>-->
    <div class="customer__pool__header">
      <div class="header--back iconfont" @click="$router.push('/')"><span>&#xe600;</span></div>
      <div class="header--text">客户回款记录</div>
      <div class="header--back"></div>
    </div>
    <div class="customer__pool__line"></div>
    <div class="customer__pool__item" v-if="repaymentList.length>0">
      <div
        class="customer__item"
        v-for="item in repaymentList"
        :key="item.serno"
        @click="handleToPoolDetail(item.cusId,item.comBrId)"
      >
        <div class="md-example-child md-example-child-detail-item md-example-child-detail-item-0">
          <md-field>
            <md-detail-item :title="item.opAccountName" content="" bold />
            <md-detail-item title="到款金额(元)" :content="item.amount|filerthousandchar" />
            <md-detail-item title="到款时间" :content="item.recordDate" />
          </md-field>
        </div>
      </div>
    </div>
    <div class="customer__pool__item" v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
import { addthousandchar } from '../tools/common'
import { Field, DetailItem } from 'mand-mobile'
import recordPageTime from '../mixin/minin'
export default {
  name: 'CustomerPool',
  components: {
    [Field.name]: Field,
    [DetailItem.name]: DetailItem
  },
  data () {
    return {
      // date: '',
      // minDate: new Date(1970, 0, 1),
      // show: false,
      // radio: '1'
      pageNum: 1,
      pageSize: 10,
      rowsTotal: 0,
      repaymentList: [],
      scrollCustomNum: 50,
      scrollCustomFlag: true // 控制滑动pageNum在没有返回值的时候不能加1
    }
  },
  beforeMount () {
    this.getRepmentList()
  },
  mounted () {
    window.addEventListener('scroll', this.handleToCustomListScroll, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleToCustomListScroll, true)
  },
  methods: {
    // 格式化时间格式
    // formatDate (date) {
    //   return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    // },
    // 修改时间区间点击的事件
    // onConfirm (date) {
    //   console.log('time')
    //   const [start, end] = date
    //   this.show = false
    //   this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`
    // }
    // 获取repyment list
    async getRepmentList () {
      const result = await get('/api/CBMS-APP/repayment/list',
        {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
      if (result.success) {
        this.scrollCustomFlag = true
        this.rowsTotal = result.data.total
        this.repaymentList = this.repaymentList.concat(result.data.records)
      }
    },
    // 跳转到pooldetail
    handleToPoolDetail (cusId, comBrId) {
      this.$router.replace({ name: 'pooldetail', params: { cusId, comBrId } })
    },
    // 滑动到底部触发
    async handleToCustomListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollCustomNum >= scrollHeight) {
        if (this.repaymentList.length < this.rowsTotal && this.scrollCustomFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollCustomFlag = false
          this.getRepmentList()
        } else if (this.repaymentList.length === this.rowsTotal) {
          this.scrollCustomNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    }
  },
  filters: {
    filerthousandchar (num) {
      return addthousandchar(num.toString())
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.customer__pool
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  overflow-y : scroll
  &.active
   padding-bottom : 64px
  .customer__pool__header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    display : flex
    box-sizing : border-box
    height : 85px
    line-height : 85px
    background : #687591
    font-family: MyriadPro-Regular
    font-size: 38px
    font-weight: normal
    font-stretch: normal
    color: #ffffff
    .header--back
      padding-left : 16px
      width : 150px
      font-size: 48px
    .header--text
      text-align : center
      flex : 1
  .customer__pool__line
    width : 100%
    height : 85px
  .customer__pool__item
    margin : 16px 16px 0 16px
    padding-bottom : 32px
    .customer__item
      border : 2px solid #999999
      border-radius : 8px
      padding : 16px
      margin-bottom : 16px
      .customer-item-title
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        font-size : 26px
        color : #323233
      .customer__pool__content
        margin-top : 8px
        .customer__pool__content--title
          display : flex
          justify-content : center
          align-items : center
          padding : 8px 0
          font-family: MyriadPro-Regular
          font-weight: normal
          font-stretch: normal
          font-size : 26px
          color : #323233
          span
            flex : 1
      .customer__pool__remind
        margin-top : 8px
        padding : 8px 0
        font-family: MyriadPro-Regular
        font-weight: normal
        font-stretch: normal
        font-size : 26px
        color : #333333
        .customer__pool__remind__text
          padding-right : 24px
</style>
